import React, { lazy } from 'react'
import { Routes, Route } from 'react-router'
import { PrivateRoute } from 'website'
import SurveyProvider from 'website/Surveys/views/SurveyQuestions/SurveyProvider'

const SurveyDetails = lazy(() => import(/* webpackChunkName: "survey-details-page" */ '../Surveys/views/SurveyDetails'))

const SurveyQuestions = lazy(() => import(/* webpackChunkName: "survey-questions-page" */ '../Surveys/views/SurveyQuestions'))
const SurveyOutro = lazy(() => import(/* webpackChunkName: "survey-questions-page" */ '../Surveys/views/SurveyOutro'))

const SendSurvey = lazy(() => import(/* webpackChunkName: "send-survey-page" */ '../Surveys/views/SendSurvey'))

const SurveyParticipantResponses = lazy(
	() => import(/* webpackChunkName: "survey-responses-page" */ '../Surveys/views/SurveyParticipantResponses'),
)

const SurveyRoutes = (props: Record<string, any>) => {
	const p = props as any
	return (
		<SurveyProvider setSuccessMessage={props.setSuccessMessage} setErrorMessage={props.setErrorMessage}>
			<Routes>
				<Route path='send/:currentstep/:variant' element={<PrivateRoute><SendSurvey {...p} /></PrivateRoute>} />
				<Route path='send/:currentstep' element={<PrivateRoute><SendSurvey {...p} /></PrivateRoute>} />
				<Route path='send' element={<PrivateRoute><SendSurvey {...p} /></PrivateRoute>} />
				<Route path='responses/*' element={<PrivateRoute><SurveyParticipantResponses {...p} /></PrivateRoute>} />
				<Route path='questions' element={<PrivateRoute><SurveyQuestions {...p} /></PrivateRoute>} />
				<Route path='outro' element={<PrivateRoute><SurveyOutro {...p} /></PrivateRoute>} />
				<Route path='new' element={<PrivateRoute><SurveyDetails {...p} /></PrivateRoute>} />
				<Route index element={<PrivateRoute><SurveyDetails {...p} /></PrivateRoute>} />
			</Routes>
		</SurveyProvider>
	)
}

export default SurveyRoutes
